import { Suspense } from 'react';
import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { Skeleton } from '@sara/ui/components/skeleton';
import { ApiKeyListContainerContent } from './ApiKeyListContainerContent';
import type { ApiKeyListContainerProps } from './types';

export type { ApiKeyListContainerProps };

function ApiKeyListSkeleton() {
  return (
    <div className="divide-y divide-border/70 border-y border-border/70">
      {[0, 1, 2].map((i) => (
        <div key={i} className="flex items-center justify-between gap-6 py-5">
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-3 w-64" />
          </div>
          <Skeleton className="h-7 w-20 rounded-full" />
        </div>
      ))}
    </div>
  );
}

export function ApiKeyListContainer(props: ApiKeyListContainerProps) {
  return (
    <QueryErrorBoundary>
      <Suspense fallback={<ApiKeyListSkeleton />}>
        <ApiKeyListContainerContent {...props} />
      </Suspense>
    </QueryErrorBoundary>
  );
}
